// Gegenstandsarten. Was ein Tier abgibt und was in der Leiste liegt, ist ein Eintrag hier: id,
// Anzeigename und Symbolkennung für den Client. Ein neuer Gegenstand ist ein Dateneintrag, kein
// Code im Kern.

/**
 * Kennung einer Gegenstandsart, z. B. 'milch'. Bewusst `string` und nicht aus ITEMS abgeleitet:
 * Tests und spätere Tierarten dürfen eigene Gegenstände mitbringen, ohne den Kern anzufassen.
 * Dass SPECIES nur bekannte Gegenstände nennt, sichert ein Test, nicht der Typ.
 */
export type ItemId = string;

export interface ItemDef {
  id: ItemId;
  /** Anzeigename in der Leiste, z. B. 'Milch'. */
  name: string;
  /** Kennung des Symbols, das der Client für den Stapel zeichnet. */
  icon: string;
}

/** Alle bekannten Gegenstandsarten nach id; Schlüssel und `id` stimmen überein. */
export const ITEMS: Readonly<Record<ItemId, ItemDef>> = {
  milch: { id: 'milch', name: 'Milch', icon: 'milch' },
  /** Vom Apfelbaum auf dem eigenen Hof (task-014). */
  apfel: { id: 'apfel', name: 'Apfel', icon: 'apfel' },
};
